import ContentTypeRichText from '@aspendental/shared-components-web/lib/components/ContentTypeRichText';
import { ContentTypeRichTextContent } from '@aspendental/shared-components-web/lib/graphql/__generated/sdk';
import { Button, CardActions, CardContent, CardMedia, Grid, Card as MuiCard, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Card, SuccessCard } from '@src/lib/__generated/contentful-sdk';
type ImageAssetJson = {
  image?: {
    cdn_url?: string;
    description?: string;
  };
};
function isSuccessCard(card: SuccessCard | Card): card is SuccessCard {
  return 'cardImage' in card;
}
function getImageAsset(card: Card | SuccessCard, isSmallScreen: boolean) {
  if (isSuccessCard(card)) {
    return {
      image: card.cardImage?.url,
      description: card.imageAltText
    };
  }
  const rawImage = isSmallScreen ? card.imageAsset?.mobileImage as ImageAssetJson : card.imageAsset?.desktopImage as ImageAssetJson;
  return {
    image: rawImage?.image?.cdn_url,
    description: rawImage?.image?.description
  };
}
export default function MarketingCard({
  card
}: {
  card: SuccessCard | Card;
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    image,
    description: altText
  } = getImageAsset(card, isSmallScreen);
  const title = isSuccessCard(card) ? card.titleText : card.title;
  const description = isSuccessCard(card) ? card.descriptionText : <ContentTypeRichText content={card.richTextDescription as ContentTypeRichTextContent} disablePaddingOn={['Top', 'Bottom']} disableGutters />;
  const buttonLink = isSuccessCard(card) ? card.buttonLink : card.buttonsCollection?.items[0]?.buttonLink;
  const buttonText = isSuccessCard(card) ? card.buttonText : card.buttonsCollection?.items[0]?.label;
  return <Grid item xs={12} sm={6} md={4} key={card?.sys?.id} data-sentry-element="Grid" data-sentry-component="MarketingCard" data-sentry-source-file="MarketingCard.tsx">
			<MuiCard elevation={0} variant="outlined" sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }} data-sentry-element="MuiCard" data-sentry-source-file="MarketingCard.tsx">
				<CardMedia component="img" image={image ?? ''} alt={altText ?? ''} data-sentry-element="CardMedia" data-sentry-source-file="MarketingCard.tsx" />
				<CardContent sx={{
        marginBottom: 'auto'
      }} data-sentry-element="CardContent" data-sentry-source-file="MarketingCard.tsx">
					<Typography sx={{
          mb: 3
        }} variant="header3" color="text.primary" data-sentry-element="Typography" data-sentry-source-file="MarketingCard.tsx">
						{title}
					</Typography>
					<Typography variant={isSmallScreen ? 'bodySmallBook' : 'bodyMediumBook'} color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="MarketingCard.tsx">
						{description}
					</Typography>
				</CardContent>
				<CardActions data-sentry-element="CardActions" data-sentry-source-file="MarketingCard.tsx">
					<Button variant="primaryHC" size="M" href={buttonLink ?? ''} data-sentry-element="Button" data-sentry-source-file="MarketingCard.tsx">
						{buttonText}
					</Button>
				</CardActions>
			</MuiCard>
		</Grid>;
}